<template>
<div class="inicioWrapper">
  <DashboardFilas v-if="isADM" />
  <b-card v-else header-tag="header" class="m-3">
    <template #header>
      <h6 class="mb-0 text-center font-weight-bold titulo-sagres">Sagres - O que é?</h6>
    </template>
    <b-card-text class="text-justify">
      <p>O SAGRES é um sistema cujas funcionalidades são específicas para atuação dos Tribunais de Contas, com
        operacionalidade consagrada em vários Estados Federativos. Foi obtido, sem ônus pelo TCE-SE, através de Termo de
        Cooperação Técnica com o Tribunal de Contas do Estado do Piauí.</p>
      <p>O SAGRES dispõe de um Portal do Jurisdicionado, cujo objetivo é servir como canal de comunicação entre o TCE-SE
        e
        os Órgão Jurisdicionados, onde serão enviadas mensalmente as Prestações de Contas Eletrônicas de forma rápida,
        simples e segura.</p>
      <p>A base técnica dos dados do SAGRES são os lançamentos detalhados em contas correntes contábeis segundo as
        Normas
        Brasileiras de Contabilidade Aplicadas ao Setor Público (NBCASP), adotando-se como padrão o Plano de Contas
        Aplicado
        ao Setor Público (PCASP) da Secretaria de Tesouro Nacional – STN, revisado periodicamente, com as seguintes
        características funcionais:</p>
      <ul>
        <li>Integridade dos dados</li>
        <li>Segurança</li>
        <li>Confiabilidade</li>
        <li>Simplicidade de procedimentos</li>
        <li>Interface amigável</li>
        <li>Padronização</li>
        <li>Validação com regras contábeis</li>
      </ul>
      <p>Para mais informações, consulte o <a href="https://www.tce.se.gov.br/SitePages/jurisdicionado.aspx"
          target="_blank">portal do TCE-SE <font-awesome-icon icon="external-link-alt" class="mr-2" /></a></p>
    </b-card-text>
  </b-card>
  </div>
</template>
<script>
import { isAdmin } from "@/store";
import DashboardFilas from "@/views/DashboardFilas.vue";

export default {
  name: "inicio",
  components: {
    DashboardFilas,
  },
  computed: {
    isADM() {
      return isAdmin();
    }
  },
};
</script>